import script from "./ClosedNoticePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosedNoticePanel.vue?vue&type=script&setup=true&lang=js"

import "./ClosedNoticePanel.vue?vue&type=style&index=0&id=d56da658&scoped=true&lang=css"
import "./ClosedNoticePanel.vue?vue&type=style&index=1&id=d56da658&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d56da658"]])

export default __exports__